import { createAction } from 'redux-actions';

import { CHANGE_SCENE_SCRIPT_FOCUS } from '../constants/ActionTypes';

export const changeSceneScriptFocus = createAction(CHANGE_SCENE_SCRIPT_FOCUS);
